import React from 'react';
import DocumentItem from 'features/shared/documents/components/DocumentItem';
import { Document } from 'core/types';

interface DocumentsListViewProps {
  documents: Document[];
  onDocumentClick: (document: Document) => void;
}

const DocumentsListView: React.FC<DocumentsListViewProps> = ({
  documents,
  onDocumentClick
}) => {
  return (
    <>
      {documents.map((document: Document, i: number) => (
        <DocumentItem
          key={`item-${i}`}
          document={document}
          onClick={onDocumentClick}
        />
      ))}
    </>
  );
};

export default DocumentsListView;
